<template>
  <div class="container">
    <h2>Campos adicionales</h2>

    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field">
          <label class="label">Tipo de Institución:</label>
          <div class="control has-icons-left">
            <span class="select is-fullwidth is-primary">
              <select v-model="tipoSeleccionado" required="required" @click="setTipoSeleccionado">
                <option disabled value>Seleccione un tipo</option>
                <option v-for="tipo in tiposVinculacion" :key="tipo.id" :value="tipo.id">{{tipo.nombre}}</option>
              </select>
            </span>
            <span class="icon is-small is-left">
              <i class="fas fa-file-contract"></i>
            </span>
          </div>
        </div>
        <div class="field"><!-- Campo Sede Educativa -->
            <label class="label">Institución Educativa- Sede:</label>
            <div class="control has-icons-left is-expanded ">
              <span class="select is-fullwidth is-primary" @click="setSedeSeleccionada">
                <select
                  v-model="sedeSeleccionada"
                  required="required"                   
                >
                    <option
                        v-for="sede in sedesStore"
                        :key="sede.id"
                        :value="sede.id"
                    >
                        {{ sede.ie }} - {{ sede.sede }}
                    </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-building"></i>
              </span>
            </div>
        </div>
      
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-body">
          <div class="field">
          <label class="label">Área a la que pertenece</label>
          <div class="control has-icons-left is-expanded">
            <span class="select is-fullwidth is-primary">
              <select v-model="areaSeleccionada" required="required"  @click="setAreaSeleccionada">
                <option v-for="area in areas" :key="area.id" :value="area.id">{{ area.nombre }}</option>
              </select>
            </span>
            <span class="icon is-small is-left">
              <i class="fas fa-book-reader"></i>
            </span>
          </div>
        </div>
        
        <div class="field">
          <label class="label">Nivel al que pertenece:</label>
          <div class="control has-icons-left">
            <span class="select is-fullwidth is-primary">
              <select v-model="nivelSelccionado" required="required"  @click="setNivelSeleccionado">
                <option disabled value>Seleccione un nivel</option>
                <option
                  v-for="nivel in niveles"
                  :key="nivel.id"
                  :value="nivel.id"
                >{{nivel.nombre}}</option>
              </select>
            </span>
            <span class="icon is-small is-left">
              <i class="fas fa-sort-amount-up-alt"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "./Inputs/MultiSelect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapState } from "vuex";
import axios from "axios";
import { detalleMunicipio, sedesMunicipio, areas, tiposVin, niveles, tipoInstituciones } from "../api";

export default {
  name: "campos-adicionales",
  components: { MultiSelect, vSelect },
  data: function () {
    return {
      
      tipoSeleccionado: null,
      nivelSelccionado: "",
      areaSeleccionada: "",
      sedeSeleccionada: null,
      areas: [],
      niveles: [],
      tiposVinculacion: [],
      errores: {},
      sedes: null,
    };
  },
  computed: {
    ...mapState(["sedesStore",
    "tipoVinStore", 
    "nivelStore",
    "areaStore",
    "sedeStore",
    "municipioIdStore"]),
  },
  methods: {
    setTipoSeleccionado(){
      //this.$store.state.tipoStore = this.tipoSeleccionado
       if(this.$store.state.municipioIdStore!==null && this.tipoSeleccionado !== null){
         this.fetchSedes(this.$store.state.municipioIdStore, this.tipoSeleccionado)
      }
      this.$store.commit("setTipoVin",this.tipoSeleccionado)
    },
    setNivelSeleccionado(){
      this.$store.commit("setNivel",this.nivelSelccionado)
    },
    setAreaSeleccionada(){
      this.$store.commit("setArea",this.areaSeleccionada)
    },
    setSedeSeleccionada(){
      this.$store.commit("setSede",this.sedeSeleccionada)
    },
    fetchSedes(municipioId,tipoIns) {
      this.consultando = true;
      axios
        .get(sedesMunicipio(municipioId,tipoIns))
        .then((response) => {
          // console.log(response);
          this.sedes = response.data.results;
          this.$store.state.sedesStore = this.sedes;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
   fetchTipoInstitu() {
      //this.consultando = true;
      axios
        .get(tipoInstituciones)
        .then((response) => {
          this.tiposVinculacion = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    },


    fetchNiveles() {
      //this.consultando = true;
      axios
        .get(niveles)
        .then((response) => {
          this.niveles = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    }, 
    fetchAreas() {
      //this.consultando = true;
      axios
        .get(areas)
        .then((response) => {
          this.areas = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    },           

  },
  mounted() {
    //this.fetchTipoVin();
    this.fetchNiveles();
    this.fetchAreas();
    this.fetchTipoInstitu();
  },

 
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
